// extracted by mini-css-extract-plugin
export var content = "styles-module--content--b7c1a";
export var images_wrapper = "styles-module--images_wrapper--46a1f";
export var text_wrapper = "styles-module--text_wrapper--810ec";